import { FrameLogo } from '@aipb/gulliver/env/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fr-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  @Input() logo: FrameLogo;
  @Input() classes: string;
  @Input() htmlId: string;
  @Input() lang: string;
}
